import Vue from 'vue'
import Router from 'vue-router'

import AuthMiddleware from '../middleware/auth';

import Home from '@/views/Home'
import About from '@/views/About'
import Contact from '@/views/Contact'
import StoreLocator from '@/views/StoreLocator'
import Faqs from '@/views/Faqs'
import Products from '@/views/products/Products'
import SignUp from '@/views/auth/SignUp'
import SignIn from '@/views/auth/SignIn'
import VerifyAccount from '@/views/auth/VerifyAccount'
import ForgotPassword from '@/views/auth/ForgotPassword'
import ResetPassword from '@/views/auth/ResetPassword'
import UpdatePassword from '@/views/profile/UpdatePassword'
import UpdateProfile from '@/views/profile/UpdateProfile'
import Profile from '@/views/profile/Profile'
import MyOrders from '@/views/orders/Orders'
import OrderDetails from '@/views/OrderDetails'
import Wishlist from '@/views/Wishlist'
import Success from '@/views/Success'
import Failed from '@/views/Failed'
import ProductDetails from '@/views/products/ProductDetails.vue'
// import ComingSoon from '@/views/ComingSoon'
import Blog from '@/views/Blog'
import BookYourJob from '@/views/BookYourJob'
import ReturnPolicy from "@/views/ReturnPolicy";
import ProductEnquiry from "@/views/ProductEnquiry"
import Service from "@/views/Service.vue"
import SearchProducts from "@/views/search/SearchProducts.vue"
import CheckoutPage from "@/views/checkout/CheckoutPage";
import Cart from "@/views/cart/Cart";

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/about',
            name: 'about',
            component: About
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        },
        {
            path: '/our-services',
            name: 'our-services',
            component: Service
        },
        {
            path: "/store-locator",
            name: "store-locator",
            component: StoreLocator
        },
        {
            path: "/faqs",
            name: "faqs",
            component: Faqs
        },
        {
            path: "/products/:category?",
            name: "products",
            component: Products
        },
        {
            path: "/search",
            name: "search-products",
            component: SearchProducts
        },
        {
            path: "/signup",
            name: "signup",
            component: SignUp,
            beforeEnter: AuthMiddleware.guest
        },
        {
            path: "/verify-account",
            name: "verify-account",
            component: VerifyAccount,
            beforeEnter: AuthMiddleware.guest
        },
        {
            path: "/signin",
            name: "signin",
            component: SignIn,
            beforeEnter: AuthMiddleware.guest
        },
        {
            path: "/forgot-password",
            name: "forgot-password",
            component: ForgotPassword,
            beforeEnter: AuthMiddleware.guest
        },
        {
            path: "/reset-password",
            name: "reset-password",
            component: ResetPassword,
            beforeEnter: AuthMiddleware.guest
        },
        {
            path: "/update-password",
            name: "update-password",
            component: UpdatePassword,
            beforeEnter: AuthMiddleware.user

        },
        {
            path: "/update-profile",
            name: "update-profile",
            component: UpdateProfile,
            beforeEnter: AuthMiddleware.user
        },
        {
            path: "/profile",
            name: "profile",
            component: Profile,
            beforeEnter: AuthMiddleware.user
        },
        {
            path: "/my-orders",
            name: "my-orders",
            component: MyOrders,
            beforeEnter: AuthMiddleware.user
        },
        {
            path: "/order-details",
            name: "order-details",
            component: OrderDetails,
            beforeEnter: AuthMiddleware.user
        },
        {
            path: "/wishlist",
            name: "wishlist",
            component: Wishlist,
            beforeEnter: AuthMiddleware.user
        },
        {
            path: "/success",
            name: "success",
            component: Success
        },
        {
            path: "/failed",
            name: "failed",
            component: Failed
        },
        {
            path: "/product-details/:slug",
            name: "product-details",
            component: ProductDetails,
            reuse: true
        },
        {
            path: "/cart",
            name: "cart",
            component: Cart
        },
        {
            path: "/blog",
            name: "blog",
            component: Blog
        },
        {
            path: "/book-your-job",
            name: "book-your-job",
            component: BookYourJob
        },
        {
            path: "/return-policy",
            name: "return-policy",
            component: ReturnPolicy
        },
        {
            path: "/checkout",
            name: "checkout",
            component: CheckoutPage,
            beforeEnter: AuthMiddleware.user
        },
        // {
        //     path: "/checkout/:slug",
        //     name: "checkout",
        //     component: CheckoutPage,
        //     beforeEnter: AuthMiddleware.user
        // },
        {
            path: "/product-enquiry/:slug",
            name: "product-enquiry",
            component: ProductEnquiry
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
})
